import { Controller } from "stimulus"

export default class extends Controller {

  connect() {
    this.toggle();
  }

  get checkboxTarget() {
    return this.element.querySelector(`[data-toggle-target="checkbox"]`)
  }
  get fieldsTarget() {
    return this.element.querySelector(`[data-toggle-target="fields"]`)
  }
  toggle() {
    const isChecked = this.checkboxTarget.checked;
    this.fieldsTarget.classList.toggle("d-none", !isChecked);
  }
}
